import { makeStyles, TextField } from '@material-ui/core';

import MomentUtils from '@date-io/moment';

import React, { useEffect, useState } from 'react';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker
} from '@material-ui/pickers';
import Icons from 'components/Icons';

interface DateSelectorProps {
  label: string;
  onSelect: Function;
  disabled: boolean;
  shouldClear?: boolean;
}
const useStyles = makeStyles({
  date: {
    height: '40px',
    backgroundColor: '#F2F2F2',
    width: '100%',
    border: 'none',
    outline: 'none',
    borderRadius: '25px',
    textDecoration: 'none',
    '& .MuiIconButton-root': {
      padding: 0,
      position: 'absolute',
      top: '-4px',
      left: '6px',
      color: 'rgb(47, 47, 48)'
    },
    '& .MuiInputBase-input': {
      height: '36px',
      border: 'none',
      marginLeft: '28px',
      color: 'grey',
      paddingLeft: '12px'
    }
  },
  label: {
    color: 'grey',
    position: 'absolute',
    top: '16px',
    left: '36px',
    textDecoration: 'none'
  },
  closeIconContainer: {
    position: 'absolute',
    right: '12px',
    top: '10px',
    height: '24px',
    width: '24px',
    cursor: 'pointer'
  }
});

function DateSelector({
  label,
  onSelect,
  disabled,
  shouldClear
}: DateSelectorProps) {
  const classes = useStyles();
  const [selectedDate, handleDateChange] = useState(null);
  const [open, setOpen] = useState(false);
  const isDateSelected = selectedDate === null ? false : true;

  useEffect(() => {
    if (shouldClear) handleDateChange(null);
  }, [shouldClear]);

  return (
    <div style={{ position: 'relative' }}>
      <MuiPickersUtilsProvider utils={MomentUtils}>
        <KeyboardDatePicker
          disabled={disabled}
          openTo="year"
          open={open}
          onOpen={() => setOpen(true)}
          onClose={() => setOpen(false)}
          className={classes.date}
          autoOk
          label={selectedDate === null ? label : ''}
          format="DD-MM-YYYY"
          value={selectedDate}
          InputProps={{
            disableUnderline: true,
            readOnly: disabled
          }}
          InputLabelProps={{
            className: classes.label,
            style: {
              marginLeft: isDateSelected ? '40x' : '0px',
              position: 'absolute',
              top: isDateSelected ? '12px' : '-6px',
              left: isDateSelected ? '36px' : '36px'
            }
          }}
          KeyboardButtonProps={{
            style: {
              position: 'absolute',
              top: isDateSelected ? '12px' : '-4px',
              color: 'rgb(47, 47, 48)'
            }
          }}
          onChange={(date: any) => {
            handleDateChange(date);
            onSelect(date);
          }}
          TextFieldComponent={props => {
            return <TextField {...props} onClick={() => setOpen(true)} />;
          }}
        />
      </MuiPickersUtilsProvider>
      <div
        className={classes.closeIconContainer}
        onClick={() => handleDateChange(null)}
      >
        <Icons.CloseIcon />
      </div>
    </div>
  );
}

export default DateSelector;
